module.exports = __webpack_public_path__ + "img/1475404586.b26c813d.jpg";